export enum IrButtonsEnum {
  PREVIEW = 'PREVIEW',
  EDIT = 'EDIT',
  SHARE = 'SHARE',
  SAVE = 'SAVE',
  CANCEL = 'CANCEL',
  CREATE = 'CREATE',
  EXPORT = 'EXPORT'
}

export enum IrTabsEnum {
  FUND_POSITION = 'FUND POSITION',
  INVESTOR_POSITION = 'INVESTOR POSITION',
}
